export default "__VITE_ASSET__BW_MG$3j__"